// extracted by mini-css-extract-plugin
module.exports = {"productcontent":"smart-home-panel-2_productcontent__6ud5l"};